import React, { useState, useEffect } from 'react';
import './RegistrationForm.css';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
//import bcrypt from "bcryptjs";

const RegistrationForm = ({ API_URL }) => {
    const navigate = useNavigate();

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [mobile, setMobile] = useState('');
    const [accountType, setAccountType] = useState('police');
    const [designation, setDesignation] = useState('');
    const [preferredLanguage, setPreferredLanguage] = useState('English');
    const [state, setState] = useState('Delhi');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [termsAccepted, setTermsAccepted] = useState(false);

    const [isEmailValid, setIsEmailValid] = useState(false);

    const [submitOk, setSubmitOk] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [errorMessage, setErrorMessage] = useState(null);
    const [showPopup, setShowPopup] = useState(false);
    const [showAccountCreatedPopup, setShowAccountCreatedPopup] = useState(false);

    useEffect(() => {
        const length = 8;
        const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const bytes = new Uint8Array(length);
        let out = "";
        for (let i = 0; i < length; i++) {
            out += chars[Math.floor(Math.random() * chars.length)];
        }
        setPassword(out);
        setConfirmPassword(out);
    }, []);

    const handleFirstNameChange = (e) => {
        const value = e.target.value;
        setFirstName(value);
    };

    const handleLastNameChange = (e) => {
        const value = e.target.value;
        setLastName(value);
    };

    const [isValidMobile, setIsValidMobile] = useState(false);
    const handleMobileChange = (e) => {
        let value = e.target.value || "";

        // allow only digits
        if (!/^\d*$/.test(value)) return;

        // remove leading 0
        if (value.startsWith("0")) value = value.substring(1);

        // cap at 10 digits
        if (value.length > 10) value = value.substring(0, 10);

        setMobile(value);
        setEmail(value); // Set email as mobile number

        // Indian mobile validation: 10 digits starting with 6-9
        setIsValidMobile(/^[6-9]\d{9}$/.test(value));
    };

    const handleEmailChange = (e) => {
        const value = e.target.value.toLowerCase();
        setEmail(value);
        // Regular expression for basic email validation
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsEmailValid(emailPattern.test(value));
    };

    const handleAccountTypeChange = (e) => {
        const value = e.target.value;
        setAccountType(value);
    };

    const handleDesignationChange = (e) => {
        const value = e.target.value;
        setDesignation(value);
    };

    const handleStateChange = (e) => {
        const value = e.target.value;
        setState(value);
    };

    const onConfirmSubmit = async () => {
        setShowPopup(false);
        await registerUser(); // registerUser already does e?.preventDefault?.()
    };

    const changeEmail = (e) => {
        setShowPopup(false);
        setSubmitOk(true);
    };

    const closeErrorPopup = (e) => {
        setErrorMessage(null);
        setSubmitOk(true);
        setIsLoading(false);
    };

    const registerUser = async (e) => {
        e?.preventDefault?.();

        if (!termsAccepted) {
            setErrorMessage("Please accept the Terms of Use and Privacy Policy to continue.");
            return;
        }

        setShowPopup(false);
        setIsLoading(true);

        /*
        // Generate a salt (you can adjust the salt rounds for security)
        const saltRounds = 10;
        const salt = bcrypt.genSaltSync(saltRounds);
        //console.log("Salt: " + salt);

        // Hash the password with the salt
        const hash = bcrypt.hashSync(password, salt);
        //console.log("Hash: " + hash);
        */

        const request = {
            firstName: firstName,
            lastName: lastName,
            email: mobile,
            mobile: mobile,
            nativeLanguage: preferredLanguage,
            accountType: accountType,
            designation: designation,
            state: state,
            // password: hash,
            // salt: salt,
            password: password,
        }

        try {
            const response = await axios.post(API_URL + `/user`, request, {
                headers: {
                    'Content-Type': 'application/json', // Set the content type to JSON
                },
            });

            console.log(response.data);
            //alert(response.data);

            setShowAccountCreatedPopup(true);
        } catch (error) {
            if (error.response) {
                // Server responded with a status code other than 2xx
                //console.error("Server Error Response:", error.response.data);
                if (error.response.data.error) {
                    setErrorMessage(error.response.data.error);
                } else {
                    setErrorMessage("An unexpected error occurred.  Please try again later.")
                }
                //alert(error.response.data.error || "An unexpected error occurred.");
            } else {
                //console.error("Error fetching data:", error);
                //alert("An error occurred while processing the request. Please try again later.");
                setErrorMessage("An unexpected error occurred.  Please try again later.")
            }
        } finally {
            setIsLoading(false);
            setSubmitOk(false);
        }
    };

    const handlePasswordChange = (e) => {
        const value = e.target.value;
        setPassword(value);
    };

    const handleCinfirmPasswordChange = (e) => {
        const value = e.target.value;
        setConfirmPassword(value);
    };

    const handleTermsChange = (e) => {
        setTermsAccepted(e.target.checked);
    };

    // useEffect(() => {
    //     document.body.style.backgroundColor = "white";
    // }, []);

    useEffect(() => {
        if (firstName.length === 0) {
            setSubmitOk(false);
            return;
        }

        if (lastName.length === 0) {
            setSubmitOk(false);
            return;
        }

        if (!isEmailValid) {
            setSubmitOk(false);
            return;
        }

        if (mobile.length === 0) {
            setSubmitOk(false);
            return;
        }

        setSubmitOk(true);
    }, [firstName, lastName, email, isEmailValid, mobile, accountType, state]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitOk(false);
        setShowPopup(true);
    };

    const handleLogin = () => {
        setShowAccountCreatedPopup(false);
        navigate('/login', {
            state: {
                email: email
            },
        });
    }

    const handlePreferredLanguageChange = (e) => setPreferredLanguage(e.target.value);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', marginTop: '-50px' }}>
            <Navbar />
            <main
                style={{
                    flex: '1',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '20px',
                    backgroundColor: '#f9f9f9',
                }}
            >
                <div
                    className="form-container"
                    style={{
                        backgroundColor: 'white',
                        color: 'black',
                        width: '100%',
                        maxWidth: '800px',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                        borderRadius: '8px',
                        padding: '20px',
                        marginBottom: '10px',
                    }}
                >
                    <form style={{ backgroundColor: 'white' }}>
                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
                            <h2>Register</h2>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <div className="form-grid">
                                <div className="form-group" style={{ alignItems: 'centre', textAlign: 'centre' }}>
                                    <label style={{ alignItems: 'left', textAlign: 'left' }}>First Name</label>
                                    <input
                                        type="text"
                                        name="firstName"
                                        value={firstName}
                                        onChange={handleFirstNameChange}
                                        required
                                    />
                                </div>
                                <div className="form-group" style={{ alignItems: 'centre', textAlign: 'centre' }}>
                                    <label style={{ alignItems: 'left', textAlign: 'left' }}>Last Name</label>
                                    <input
                                        type="text"
                                        name="lastName"
                                        value={lastName}
                                        onChange={handleLastNameChange}
                                        required
                                    />
                                </div>

                                {/* <div className="form-group" style={{ alignItems: 'centre', textAlign: 'centre' }}>
                                    <label style={{ alignItems: 'left', textAlign: 'left' }}>Email</label>
                                    <input
                                        type="text"
                                        name="email"
                                        value={email}
                                        onChange={handleEmailChange}
                                        required
                                    />
                                    {!isEmailValid && email.length > 0 && (
                                        <small style={{ color: 'red' }}>Invalid email</small>
                                    )}
                                </div> */}
                                <div className="form-group" style={{ alignItems: 'centre', textAlign: 'centre' }}>
                                    <label style={{ alignItems: 'left', textAlign: 'left' }}>Designation</label>
                                    <input
                                        type="text"
                                        name="designation"
                                        value={designation}
                                        onChange={handleDesignationChange}
                                        required
                                    />
                                </div>
                                <div className="form-group">
                                    <label style={{ alignItems: 'left', textAlign: 'left' }}>Mobile</label>
                                    <input
                                        type="text"
                                        name="mobile"
                                        value={mobile}
                                        onChange={handleMobileChange}
                                        required
                                    />
                                    {mobile.length > 0 && !isValidMobile && (
                                        <small style={{ color: 'red' }}>Invalid number</small>
                                    )}
                                </div>

                                {/* <div className="form-group" style={{ alignItems: 'centre', textAlign: 'centre' }}>
                                    <label style={{ alignItems: 'left', textAlign: 'left' }}>Account Type</label>
                                    <select id="accountType" name="accountType" className="signup-select" onChange={handleAccountTypeChange} value={accountType} required>
                                        <option value="police">Police</option>
                                        <option value="advocate">Advocate</option>
                                    </select>
                                </div>
                                <div className="form-group" style={{ alignItems: 'centre', textAlign: 'centre' }}>
                                    <label style={{ alignItems: 'left', textAlign: 'left' }}>Designation</label>
                                    <input
                                        type="text"
                                        name="designation"
                                        value={designation}
                                        onChange={handleDesignationChange}
                                        required
                                    />
                                </div> */}

                                <div className="form-group">
                                    <label style={{ alignItems: 'left', textAlign: 'left' }}>Preferred Language</label>
                                    <select
                                        id="preferredLanguage"
                                        name="preferredLanguage"
                                        className="signup-select"
                                        onChange={handlePreferredLanguageChange}
                                        value={preferredLanguage}
                                        required
                                    >
                                        <option value="English">English</option>
                                        <option value="Hindi">Hindi</option>
                                        <option value="Gujarati">Gujarati</option>
                                        <option value="Marathi">Marathi</option>
                                        <option value="Bengali">Bengali</option>
                                        <option value="Telugu">Telugu</option>
                                        <option value="Tamil">Tamil</option>
                                        <option value="Kannada">Kannada</option>
                                        <option value="Malayalam">Malayalam</option>
                                        <option value="Punjabi">Punjabi</option>
                                        <option value="Urdu">Urdu</option>
                                    </select>
                                </div>

                                <div className="form-group" style={{ alignItems: 'centre', textAlign: 'centre' }}>
                                    <label style={{ alignItems: 'left', textAlign: 'left' }}>State</label>
                                    <select id="state" name="state" className="signup-select" onChange={handleStateChange} value={state} required>
                                        <option value="Andaman and Nicobar">Andaman and Nicobar</option>
                                        <option value="Andhra Pradesh">Andhra Pradesh</option>
                                        <option value="Arunachal Pradesh">Arunachal Pradesh</option>
                                        <option value="Assam">Assam</option>
                                        <option value="Bihar">Bihar</option>
                                        <option value="Chandigarh">Chandigarh</option>
                                        <option value="Chhattisgarh">Chhattisgarh</option>
                                        <option value="Dadra and Nagar Haveli">Dadra and Nagar Haveli</option>
                                        <option value="Delhi">Delhi</option>
                                        <option value="Goa">Goa</option>
                                        <option value="Gujarat">Gujarat</option>
                                        <option value="Haryana">Haryana</option>
                                        <option value="Himachal Pradesh">Himachal Pradesh</option>
                                        <option value="Jammu and Kashmir">Jammu and Kashmir</option>
                                        <option value="Jharkhand">Jharkhand</option>
                                        <option value="Karnataka">Karnataka</option>
                                        <option value="Kerala">Kerala</option>
                                        <option value="Lakshadweep">Lakshadweep</option>
                                        <option value="Madhya Pradesh">Madhya Pradesh</option>
                                        <option value="Maharashtra">Maharashtra</option>
                                        <option value="Manipur">Manipur</option>
                                        <option value="Meghalaya">Meghalaya</option>
                                        <option value="Mizoram">Mizoram</option>
                                        <option value="Nagaland">Nagaland</option>
                                        <option value="Orissa">Orissa</option>
                                        <option value="Puducherry">Puducherry</option>
                                        <option value="Punjab">Punjab</option>
                                        <option value="Rajasthan">Rajasthan</option>
                                        <option value="Sikkim">Sikkim</option>
                                        <option value="Tamil Nadu">Tamil Nadu</option>
                                        <option value="Tripura">Tripura</option>
                                        <option value="Uttar Pradesh">Uttar Pradesh</option>
                                        <option value="Uttarakhand">Uttarakhand</option>
                                        <option value="West Bengal">West Bengal</option>
                                    </select>
                                </div>

                                {/* <div className="form-group" style={{ alignItems: 'centre', textAlign: 'centre' }}>
                                    <label style={{ alignItems: 'left', textAlign: 'left' }}>Password</label>
                                    <input
                                        type="password"
                                        name="password"
                                        value={password}
                                        onChange={handlePasswordChange}
                                        required
                                    />
                                </div>
                                <div className="form-group" style={{ alignItems: 'centre', textAlign: 'centre' }}>
                                    <label style={{ alignItems: 'left', textAlign: 'left' }}>Confirm Password</label>
                                    <input
                                        type="password"
                                        name="confirmPassword"
                                        value={confirmPassword}
                                        onChange={handleCinfirmPasswordChange}
                                        disabled={password === ''}
                                        required
                                    />
                                    {password.length > 0 && confirmPassword.length > 0 && password !== confirmPassword && (
                                        <small style={{ color: 'red' }}>Password does not match</small>
                                    )}
                                </div> */}
                            </div>
                        </div>

                        {/* Terms and Conditions Checkbox */}
                        <div className="terms-checkbox-container" >
                            <input
                                type="checkbox"
                                id="terms"
                                checked={termsAccepted}
                                onChange={handleTermsChange}
                                className="terms-checkbox"
                            />
                            <label htmlFor="terms" className="terms-label">
                                I agree to the <a href="/terms" target="_blank" rel="noopener noreferrer">Terms of Use</a> and <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                            </label>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'center' }}>
                            <button
                                type="button"
                                className="submit-button"
                                disabled={
                                    !firstName ||
                                    !designation ||
                                    !mobile ||
                                    mobile.length !== 10 ||
                                    isLoading ||
                                    password.length === 0 ||
                                    confirmPassword.length === 0 ||
                                    password !== confirmPassword ||
                                    !termsAccepted
                                }
                                onClick={() => setShowPopup(true)}
                                style={{ width: '120px', padding: '12px 15px', marginTop: '10px', fontWeight: 'bold' }}
                            >
                                {isLoading ? <div className="spinner"></div> : 'Submit'}
                            </button>
                        </div>
                        <br></br>
                        <p style={{ textAlign: "center", }}>Already have an account? Click <a href="/login" style={{ textDecoration: "underline", textUnderlineOffset: '3px' }}>here</a> to login.</p>
                    </form>

                    {errorMessage && (
                        <div className="popup-overlay">
                            <div className="popup-container">
                                <h3>Error</h3>
                                <p>{errorMessage}</p>
                                <button
                                    className="submit-popup-button"
                                    onClick={closeErrorPopup}
                                >OK</button>
                            </div>
                        </div>
                    )}

                    {showPopup && (
                        <div className="popup-overlay">
                            <div className="popup-container">
                                <h3>Confirm Mobile Number</h3>
                                Login OTP will be sent to {email}. Please confirm your mobile number.
                                <div className="popup-buttons" style={{ marginBottom: '15px' }}>
                                    <button
                                        className="cancel-button"
                                        onClick={() => changeEmail()}
                                    >Change Mobile</button>
                                    <button
                                        className="submit-popup-button"
                                        onClick={() => onConfirmSubmit()}
                                    >Confirm Mobile</button>
                                </div>
                            </div>
                        </div>
                    )}

                    {showAccountCreatedPopup && (
                        <div className="popup-overlay">
                            <div className="popup-container">
                                <h3>Registration Successful</h3>
                                Your account has been created successfully! Please log in to continue.
                                <div className="popup-buttons" style={{ marginBottom: '15px' }}>
                                    <button
                                        className="submit-popup-button"
                                        onClick={() => handleLogin()}
                                    >OK</button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default RegistrationForm;
